import { connect } from 'react-redux';

import MembershipToggle from 'components/MembershipToggle';
import { changeOrderMembership } from '../actions';

const mapStateToProps = state => ({
  isMembershipOrder: state.currentOrder.membership_order,
  hasSubscriptionCommitment: state.currentOrder.has_subscription_commitment,
});

const mapDispatchToProps = dispatch => ({
  changeOrderMembership: value => dispatch(changeOrderMembership(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MembershipToggle);



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/containers/MembershipToggle.js